// extracted by mini-css-extract-plugin
export default {"input":"Zaa-z","button":"_aa-z","selected":"aba-z","unavailable":"bba-z","oos":"cba-z","image":"dba-z","paperCutDisabledOverlay":"eba-z"};